
import { Routes } from "@angular/router";
import {
  DatabaseMigrationsComponent,
  DatabaseUpdatesComponent,
  DemouserManagementComponent,
  EditProjectComponent,
  EditTenantComponent,
  EditUserProfileComponent,
  ManageApitokensComponent,
  ManageAuditComponent,
  ManageFilesComponent,
  ManageProjectsComponent,
  ManageTenantsComponent,
  ProjectRoleTemplatesComponent,
  SelectTenantComponent,
  SelectTenantDialogComponent,
  TenantGrouprolesComponent,
  CheckUserloginComponent,
  UserChangePasswordComponent,
  UserManagementComponent,
  UserShowProfileComponent
} from 'admin';
import { ProjectResolverService, TenantResolverService, UserResolverService, UserprofileResolverService, RoutingGuardTenant } from 'shared';
import { ProjectListComponent } from 'user';
import { AppSettingsComponent } from "./app-settings/app-settings.component";
import { SquirrelDashboardComponent } from "./squirrel-dashboard/squirrel-dashboard.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";

// Alle mandantenbezogenen Routen: der Guard setzt den Mandanten (Name = :tenantId) aus der URL
const tenantGuard = [RoutingGuardTenant];

export const SquirrelLayoutRouts: Routes = [

    { path: 'check-userlogin', component: CheckUserloginComponent },
    { path: 'select-tenant', component: SelectTenantComponent },
    { path: ':tenantId/all-projects', component: ProjectListComponent, canActivate: tenantGuard },
    { path: ':tenantId/manage-apitokens', component: ManageApitokensComponent, canActivate: tenantGuard },
    { path: ':tenantId/manage-audit', component: ManageAuditComponent, canActivate: tenantGuard },
    { path: ':tenantId/manage-files', component: ManageFilesComponent, canActivate: tenantGuard },
    { path: ':tenantId/manage-projects', component: ManageProjectsComponent, canActivate: tenantGuard },
    { path: ':tenantId/project-role-templates', component: ProjectRoleTemplatesComponent, canActivate: tenantGuard },
    {
        path: ':tenantId/manage-projects/:id',
        component: EditProjectComponent,
        canActivate: tenantGuard,
        resolve: { resolvedData: ProjectResolverService }
    },
    { path: ':tenantId/manage-users', component: UserManagementComponent, canActivate: tenantGuard },
    {
        path: ':tenantId/manage-users/:id',
        component: EditUserProfileComponent,
        canActivate: tenantGuard,
        resolve: { resolvedData: UserResolverService }
    },
    { path: ':tenantId/manage-demousers', component: DemouserManagementComponent, canActivate: tenantGuard },
    { path: ':tenantId/manage-tenants', component: ManageTenantsComponent, canActivate: tenantGuard },
    {
        path: ':tenantId/manage-tenants/:id',
        component: EditTenantComponent,
        canActivate: tenantGuard,
        resolve: { resolvedData: TenantResolverService }
    },
    { path: ':tenantId/tenant-groups', component: TenantGrouprolesComponent, canActivate: tenantGuard },
    { path: ':tenantId/database-migrations', component: DatabaseMigrationsComponent, canActivate: tenantGuard },
    { path: ':tenantId/database-updates', component: DatabaseUpdatesComponent, canActivate: tenantGuard },
    { path: 'user-profile', component: UserProfileComponent },
    {
        path: 'user-profile/:id',
        component: UserProfileComponent, resolve: { resolvedData: UserprofileResolverService }
    },
    { path: 'user-show-profile', component: UserShowProfileComponent },
    {
        path: 'user-show-profile/:id',
        component: UserShowProfileComponent, resolve: { resolvedData: UserprofileResolverService }
    },
    { path: 'settings', component: AppSettingsComponent },
    { path: 'user-change-password', component: UserChangePasswordComponent },

];
